/**
 * COOKIES
 */
export const getCookie = (name) => {
	var v = document.cookie.match("(^|;) ?" + name + "=([^;]*)(;|$)");
	return v ? v[2] : null;
};
export const setCookie = (name, value, days) => {
	var d = new Date();
	d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
	document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
};
// setCookie("popup", "activated", 1)
export const deleteCookie = (name) => {
	setCookie(name, "", -1);
};
// deleteCookie("popup")

window.getCookie = getCookie;
window.setCookie = setCookie;
window.deleteCookie = deleteCookie;